import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.map.js";
import React from 'react';
import PropTypes from "prop-types";
import { css } from '@emotion/react';
import { keysOf, useEuiTheme, transparentize } from '../../../../../src';
import { euiCanAnimate } from '../../../../../src/global_styling/variables/animations';
import { EuiThemeAnimationSpeed, EuiThemeAnimationEasing } from '../_props';
import { getPropsFromComponent } from '../../../services/props/get_props';
import { ThemeExample } from '../_components/_theme_example';
import { ThemeValuesTable } from '../_components/_theme_values_table';
var canAnimateString = "${euiCanAnimate} {\n    transition: background ${euiTheme.animation.slow};\n  }";
var animationString = "${euiCanAnimate} {\n    transition: padding ${euiTheme.animation.slow} ${euiTheme.animation.resistance};\n  }";
export var SpeedJS = function SpeedJS(_ref) {
  var description = _ref.description;
  var _useEuiTheme = useEuiTheme(),
    euiTheme = _useEuiTheme.euiTheme;
  return ___EmotionJSX(ThemeExample, {
    title: ___EmotionJSX("code", null, "euiTheme.animation[speed]"),
    description: description,
    example: ___EmotionJSX("div", {
      css: /*#__PURE__*/css(euiCanAnimate, "{transition:background ", euiTheme.animation.slow, ";:hover{background:", transparentize(euiTheme.colors.danger, 0.25), ";}};label:SpeedJS;")
    }, ___EmotionJSX("strong", null, "Hover me")),
    snippet: canAnimateString,
    snippetLanguage: "emotion"
  });
};
SpeedJS.propTypes = {
  description: PropTypes.node
};
export var SpeedValuesJS = function SpeedValuesJS() {
  var _useEuiTheme2 = useEuiTheme(),
    euiTheme = _useEuiTheme2.euiTheme;
  var animation = euiTheme.animation;
  var speedTypes = getPropsFromComponent(EuiThemeAnimationSpeed);
  var speeds = keysOf(speedTypes);
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(ThemeValuesTable, {
    items: speeds.map(function (speed) {
      return {
        id: speed,
        token: "animation.".concat(speed),
        type: speedTypes[speed],
        value: animation[speed]
      };
    }),
    tokenColumnProps: {
      width: 'auto'
    },
    sampleColumnProps: {
      width: '80px',
      align: 'left'
    },
    render: function render(item) {
      return ___EmotionJSX("div", {
        className: 'guideSass__animRow'
      }, ___EmotionJSX("div", {
        className: 'guideSass__animParent'
      }, ___EmotionJSX("div", {
        className: "guideSass__animChild"
        // Using inline style tag to override `:focus`
        ,

        style: {
          transitionDuration: item.value
        }
      })));
    }
  }));
};
export var EasingJS = ({
  description
}) => {
  const {
    euiTheme
  } = useEuiTheme();
  return <ThemeExample title={<code>euiTheme.animation[ease]</code>} description={description} example={<div css={/*#__PURE__*/css(euiCanAnimate, "{padding:", euiTheme.size.s, ";transition:padding ", euiTheme.animation.slow, " ", euiTheme.animation.resistance, ";&:hover{padding:", euiTheme.size.xl, ";}};label:EasingJS;")}>
          <strong>Hover me</strong>
        </div>} snippet={animationString} snippetLanguage="emotion" />;
};
EasingJS.propTypes = {
  description: PropTypes.node
};
export const EasingValuesJS = () => {
  const {
    euiTheme
  } = useEuiTheme();
  const animation = euiTheme.animation;
  const easingTypes = getPropsFromComponent(EuiThemeAnimationEasing);
  const eases = keysOf(easingTypes);
  return <ThemeValuesTable items={eases.map(ease => {
    return {
      id: ease,
      token: `animation.${ease}`,
      type: easingTypes[ease],
      value: animation[ease]
    };
  })} sampleColumnProps={{
    width: '80px',
    align: 'left'
  }} valueColumnProps={{
    width: '260px'
  }} tokenColumnProps={{
    width: 'auto'
  }} render={item => <div className={'guideSass__animRow'}>
          <div className={'guideSass__animParent'}>
            <div className="guideSass__animChild"
      // Using inline style tag to override `:focus`
      style={{
        transitionTimingFunction: item.value
      }} />
          </div>
        </div>} />;
};
try {
  SpeedJS.__docgenInfo = {
    tags: {},
    filePath: '/app/src-docs/src/views/theme/other/_animation_js.tsx',
    description: '',
    displayName: 'SpeedJS',
    methods: [],
    props: {
      description: {
        defaultValue: null,
        description: '',
        name: 'description',
        parent: undefined,
        declarations: [{
          fileName: 'app/src-docs/src/views/theme/_props.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'React.ReactNode'
        }
      }
    },
    extendedInterfaces: []
  };
} catch (e) {}
try {
  EasingJS.__docgenInfo = {
    tags: {},
    filePath: '/app/src-docs/src/views/theme/other/_animation_js.tsx',
    description: '',
    displayName: 'EasingJS',
    methods: [],
    props: {
      description: {
        defaultValue: null,
        description: '',
        name: 'description',
        parent: undefined,
        declarations: [{
          fileName: 'app/src-docs/src/views/theme/_props.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'React.ReactNode'
        }
      }
    },
    extendedInterfaces: []
  };
} catch (e) {}